import { TEMPLATE_TYPE, DEVICE_PREVIEW_IMAGE_URL } from 'knowledge-content-ui/constants/ChooseTemplateConstants';
import TemplatePickerCard from './TemplatePickerCard';
import UIDeviceFrame from 'UIComponents/device/UIDeviceFrame';
import styled from 'styled-components';
import UIImage from 'UIComponents/image/UIImage';
import FormattedHTMLMessage from 'I18n/components/FormattedHTMLMessage';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const DesktopFrame = styled(UIDeviceFrame).withConfig({
  displayName: "TemplatePickerPanel__DesktopFrame",
  componentId: "sc-1ing5eg-0"
})(["max-height:586px;max-width:838px;width:100%;height:auto;"]);
const EqualSizeWrapper = styled.div.withConfig({
  displayName: "TemplatePickerPanel__EqualSizeWrapper",
  componentId: "sc-1ing5eg-1"
})(["display:flex;flex-direction:column;width:50%;flex-grow:1;flex-shrink:1;"]);
const TemplatePickerPanel = ({
  currentTemplate,
  onChooseTemplateClick,
  className
}) => {
  return /*#__PURE__*/_jsxs("div", {
    className: `flex-row ${className}`,
    children: [/*#__PURE__*/_jsxs(EqualSizeWrapper, {
      className: "p-right-7",
      children: [/*#__PURE__*/_jsxs("div", {
        className: "text-center",
        children: [/*#__PURE__*/_jsx("h3", {
          children: /*#__PURE__*/_jsx(FormattedHTMLMessage, {
            message: "knowledgeContentUI.chooseTemplate.templatePickerPanel.header"
          })
        }), /*#__PURE__*/_jsx("p", {
          children: /*#__PURE__*/_jsx(FormattedHTMLMessage, {
            message: "knowledgeContentUI.chooseTemplate.templatePickerPanel.tip"
          })
        })]
      }), /*#__PURE__*/_jsxs("div", {
        className: "justify-start flex-column",
        children: [/*#__PURE__*/_jsxs("div", {
          className: "flex-row",
          children: [/*#__PURE__*/_jsx(TemplatePickerCard, {
            className: "m-right-12",
            currentTemplate: currentTemplate,
            onChooseTemplateClick: onChooseTemplateClick,
            templateType: TEMPLATE_TYPE.CONTENT
          }), /*#__PURE__*/_jsx(TemplatePickerCard, {
            currentTemplate: currentTemplate,
            onChooseTemplateClick: onChooseTemplateClick,
            templateType: TEMPLATE_TYPE.TILES
          })]
        }), /*#__PURE__*/_jsxs("div", {
          className: "flex-row m-top-7",
          children: [/*#__PURE__*/_jsx(TemplatePickerCard, {
            className: "m-right-12",
            currentTemplate: currentTemplate,
            onChooseTemplateClick: onChooseTemplateClick,
            templateType: TEMPLATE_TYPE.MINIMAL
          }), /*#__PURE__*/_jsx(TemplatePickerCard, {
            currentTemplate: currentTemplate,
            onChooseTemplateClick: onChooseTemplateClick,
            templateType: TEMPLATE_TYPE.CARDS
          })]
        }), /*#__PURE__*/_jsx("div", {
          className: "display-inline-flex m-top-7",
          children: /*#__PURE__*/_jsx(TemplatePickerCard, {
            currentTemplate: currentTemplate,
            onChooseTemplateClick: onChooseTemplateClick,
            templateType: TEMPLATE_TYPE.DEFAULT
          })
        })]
      })]
    }), /*#__PURE__*/_jsxs(EqualSizeWrapper, {
      children: [/*#__PURE__*/_jsx(DesktopFrame, {
        type: "desktop",
        children: /*#__PURE__*/_jsx(UIImage, {
          src: DEVICE_PREVIEW_IMAGE_URL[currentTemplate]
        })
      }), /*#__PURE__*/_jsxs("div", {
        className: "m-top-7",
        children: [/*#__PURE__*/_jsx("h2", {
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: `knowledgeContentUI.chooseTemplate.templates.${currentTemplate}.title`
          })
        }), /*#__PURE__*/_jsx("p", {
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: `knowledgeContentUI.chooseTemplate.templates.${currentTemplate}.description`
          })
        })]
      })]
    })]
  });
};
export default TemplatePickerPanel;